import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, normalizeStyle as _normalizeStyle, renderList as _renderList, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "estate-boundary-drawer" }
const _hoisted_2 = { class: "drawer-layout" }
const _hoisted_3 = { class: "svg-viewer" }
const _hoisted_4 = { class: "svg-controls" }
const _hoisted_5 = { class: "zoom-level" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["viewBox"]
const _hoisted_9 = {
  key: 0,
  class: "draw-hit-area",
  x: "-9999",
  y: "-9999",
  width: "99999",
  height: "99999",
  style: {"fill":"transparent","pointer-events":"none"}
}
const _hoisted_10 = ["points"]
const _hoisted_11 = ["transform"]
const _hoisted_12 = ["x", "y", "width", "height", "href"]
const _hoisted_13 = ["x", "y", "width", "height", "rx"]
const _hoisted_14 = ["x", "y", "font-size", "dy"]
const _hoisted_15 = ["points"]
const _hoisted_16 = ["x1", "y1", "x2", "y2"]
const _hoisted_17 = ["cx", "cy", "onMousedown"]
const _hoisted_18 = { class: "boundary-panel" }
const _hoisted_19 = { class: "panel-section" }
const _hoisted_20 = { class: "boundary-status" }
const _hoisted_21 = { class: "status-ok" }
const _hoisted_22 = {
  key: 1,
  class: "status-missing"
}
const _hoisted_23 = {
  key: 0,
  class: "panel-section"
}
const _hoisted_24 = { class: "adjuster-section" }
const _hoisted_25 = { class: "control-group control-group--full" }
const _hoisted_26 = { class: "control-group" }
const _hoisted_27 = { class: "value-display" }
const _hoisted_28 = { class: "control-group" }
const _hoisted_29 = { class: "value-display" }
const _hoisted_30 = { class: "control-group" }
const _hoisted_31 = { class: "value-display" }
const _hoisted_32 = { class: "control-group" }
const _hoisted_33 = { class: "value-display" }
const _hoisted_34 = { class: "control-group" }
const _hoisted_35 = { class: "value-display" }
const _hoisted_36 = { class: "logo-upload-group" }
const _hoisted_37 = { class: "logo-upload-content" }
const _hoisted_38 = {
  key: 0,
  class: "logo-preview"
}
const _hoisted_39 = ["src"]
const _hoisted_40 = {
  key: 0,
  class: "upload-spinner"
}
const _hoisted_41 = { key: 1 }
const _hoisted_42 = { class: "panel-section completion-section" }
const _hoisted_43 = {
  key: 0,
  class: "hint"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[19] || (_cache[19] = _createElementVNode("div", { class: "drawer-header" }, [
      _createElementVNode("h2", null, "Draw Estate Boundary"),
      _createElementVNode("p", null, "Draw the outer boundary of the entire estate on the map. Double-click to finish, right-click or Backspace to undo the last point.")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "btn-icon",
            onClick: $setup.handleZoomIn,
            title: "Zoom In"
          }, "+"),
          _createElementVNode("button", {
            class: "btn-icon",
            onClick: $setup.handleZoomOut,
            title: "Zoom Out"
          }, "−"),
          _createElementVNode("button", {
            class: "btn-icon",
            onClick: $setup.handleResetView,
            title: "Reset View"
          }, "⟲"),
          _createElementVNode("div", _hoisted_5, _toDisplayString(Math.round($setup.zoomLevel * 100)) + "%", 1),
          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "controls-separator" }, null, -1)),
          (!$setup.isDrawing)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (!$setup.hasBoundary)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "btn-draw",
                      onClick: $setup.startDrawing
                    }, "Draw Estate Boundary"))
                  : (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      class: "btn-edit",
                      onClick: $setup.startDrawing
                    }, "Edit Estate Boundary"))
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("button", {
                  class: "btn-finish",
                  onClick: $setup.finishDrawing,
                  disabled: $setup.draftPoints.length < 3
                }, "✓ Finish (" + _toDisplayString($setup.draftPoints.length) + " pts)", 9, _hoisted_6),
                _createElementVNode("button", {
                  class: "btn-cancel-draw",
                  onClick: $setup.cancelDrawing
                }, "✗ Cancel"),
                _cache[6] || (_cache[6] = _createElementVNode("span", { class: "drawing-hint" }, "Double-click to finish · Right-click or Backspace to undo · Drag points to reposition", -1))
              ], 64))
        ]),
        _createElementVNode("div", {
          class: "svg-container",
          ref: "svgContainer",
          style: _normalizeStyle({ cursor: $setup.isDrawing ? 'crosshair' : $setup.isDragging ? 'grabbing' : 'grab' }),
          onWheel: _withModifiers($setup.handleWheel, ["prevent"]),
          onMousedown: $setup.handleMouseDown,
          onMousemove: $setup.handleMouseMove,
          onMouseup: $setup.handleMouseUp,
          onMouseleave: $setup.handleMouseUp,
          onClick: $setup.handleContainerClick,
          onDblclick: _withModifiers($setup.handleDoubleClick, ["prevent"]),
          onContextmenu: _withModifiers($setup.handleContextMenu, ["prevent"])
        }, [
          ($setup.svgContent)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "svg-background",
                innerHTML: $setup.svgContent,
                style: _normalizeStyle($setup.svgStyle)
              }, null, 12, _hoisted_7))
            : _createCommentVNode("", true),
          (_openBlock(), _createElementBlock("svg", {
            class: "svg-overlay",
            ref: "svgOverlay",
            style: _normalizeStyle($setup.svgStyle),
            viewBox: $setup.overlayViewBox
          }, [
            ($setup.isDrawing)
              ? (_openBlock(), _createElementBlock("rect", _hoisted_9))
              : _createCommentVNode("", true),
            ($setup.boundaryPoints.length >= 3)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("polygon", {
                    class: "estate-boundary",
                    points: $setup.boundaryPoints.map((p) => `${p.x},${p.y}`).join(' '),
                    style: _normalizeStyle({ fill: `rgba(140, 145, 150, ${$setup.estateLabelAdjustments.boundaryOpacity ?? 0.55})` })
                  }, null, 12, _hoisted_10),
                  ($setup.boundaryCentroid)
                    ? (_openBlock(), _createElementBlock("g", {
                        key: 0,
                        class: "estate-label-group",
                        transform: $setup.estateLabelGroupTransform
                      }, [
                        ($setup.logoUrl)
                          ? (_openBlock(), _createElementBlock("image", {
                              key: 0,
                              class: "estate-label-logo",
                              x: $setup.boundaryCentroid.x + $setup.estateLabelAdjustments.offsetX - $setup.logoWidth / 2,
                              y: $setup.boundaryCentroid.y + $setup.estateLabelAdjustments.offsetY - $setup.logoHeight / 2,
                              width: $setup.logoWidth,
                              height: $setup.logoHeight,
                              href: $setup.logoUrl,
                              preserveAspectRatio: "xMidYMid meet"
                            }, null, 8, _hoisted_12))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              ($setup.estateLabelBbox)
                                ? (_openBlock(), _createElementBlock("rect", {
                                    key: 0,
                                    class: "estate-label-bg",
                                    x: $setup.estateLabelBbox.x - $setup.estateLabelPadX,
                                    y: $setup.estateLabelBbox.y - $setup.estateLabelPadY,
                                    width: $setup.estateLabelBbox.width + $setup.estateLabelPadX * 2,
                                    height: $setup.estateLabelBbox.height + $setup.estateLabelPadY * 2,
                                    rx: $setup.estateLabelPillRx
                                  }, null, 8, _hoisted_13))
                                : _createCommentVNode("", true),
                              _createElementVNode("text", {
                                class: "estate-label-title",
                                ref: "estateLabelTextRef",
                                x: $setup.boundaryCentroid.x + $setup.estateLabelAdjustments.offsetX,
                                y: $setup.boundaryCentroid.y + $setup.estateLabelAdjustments.offsetY,
                                "font-size": $setup.labelFontSize,
                                "text-anchor": "middle",
                                dy: ($setup.labelFontSize * 0.35) / $setup.estateLabelAdjustments.scale
                              }, _toDisplayString($setup.labelText || $props.estateTitle), 9, _hoisted_14)
                            ], 64))
                      ], 8, _hoisted_11))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            ($setup.draftPoints.length > 0)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  ($setup.draftPoints.length >= 2)
                    ? (_openBlock(), _createElementBlock("polyline", {
                        key: 0,
                        points: [...$setup.draftPoints, $setup.mouseViewPos].map((p) => `${p.x},${p.y}`).join(' '),
                        style: {"fill":"none","stroke":"#ff6b35","stroke-width":"2","stroke-dasharray":"5, 3","pointer-events":"none"}
                      }, null, 8, _hoisted_15))
                    : ($setup.draftPoints.length === 1)
                      ? (_openBlock(), _createElementBlock("line", {
                          key: 1,
                          x1: $setup.draftPoints[0].x,
                          y1: $setup.draftPoints[0].y,
                          x2: $setup.mouseViewPos.x,
                          y2: $setup.mouseViewPos.y,
                          style: {"stroke":"#ff6b35","stroke-width":"2","stroke-dasharray":"5, 3","pointer-events":"none"}
                        }, null, 8, _hoisted_16))
                      : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.draftPoints, (point, i) => {
                    return (_openBlock(), _createElementBlock("circle", {
                      key: i,
                      cx: point.x,
                      cy: point.y,
                      r: "6",
                      style: _normalizeStyle({ fill: $setup.draggingPointIndex === i ? '#ff3300' : '#ff6b35', stroke: 'white', strokeWidth: '2', cursor: $setup.draggingPointIndex === i ? 'grabbing' : 'grab', pointerEvents: 'all' }),
                      onMousedown: _withModifiers(($event: any) => ($setup.handlePointMouseDown($event, i)), ["stop"])
                    }, null, 44, _hoisted_17))
                  }), 128))
                ], 64))
              : _createCommentVNode("", true)
          ], 12, _hoisted_8))
        ], 36)
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _cache[9] || (_cache[9] = _createElementVNode("h3", null, "Estate Boundary", -1)),
          _createElementVNode("div", _hoisted_20, [
            ($setup.hasBoundary)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_21, "✓ Boundary drawn (" + _toDisplayString($setup.boundaryPoints.length) + " points)", 1),
                  _createElementVNode("button", {
                    class: "btn-clear",
                    onClick: $setup.clearBoundary
                  }, "× Clear boundary")
                ], 64))
              : (_openBlock(), _createElementBlock("div", _hoisted_22, [...(_cache[8] || (_cache[8] = [
                  _createElementVNode("p", null, "No boundary drawn yet.", -1),
                  _createElementVNode("p", null, "Click \"Draw Estate Boundary\" to start.", -1)
                ]))]))
          ])
        ]),
        ($setup.hasBoundary)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
              _cache[17] || (_cache[17] = _createElementVNode("h3", null, "Adjust Estate Label", -1)),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _cache[10] || (_cache[10] = _createElementVNode("label", null, "Label Text", -1)),
                  _withDirectives(_createElementVNode("input", {
                    class: "form-input",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.labelText) = $event)),
                    type: "text",
                    placeholder: "Estate name shown on the map"
                  }, null, 512), [
                    [_vModelText, $setup.labelText]
                  ])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _cache[11] || (_cache[11] = _createElementVNode("label", null, "Position X", -1)),
                  _withDirectives(_createElementVNode("input", {
                    class: "control-input",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.estateLabelAdjustments.offsetX) = $event)),
                    type: "range",
                    min: "-400",
                    max: "400",
                    step: "1"
                  }, null, 512), [
                    [
                      _vModelText,
                      $setup.estateLabelAdjustments.offsetX,
                      void 0,
                      { number: true }
                    ]
                  ]),
                  _createElementVNode("span", _hoisted_27, _toDisplayString($setup.estateLabelAdjustments.offsetX) + "px", 1)
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _cache[12] || (_cache[12] = _createElementVNode("label", null, "Position Y", -1)),
                  _withDirectives(_createElementVNode("input", {
                    class: "control-input",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.estateLabelAdjustments.offsetY) = $event)),
                    type: "range",
                    min: "-400",
                    max: "400",
                    step: "1"
                  }, null, 512), [
                    [
                      _vModelText,
                      $setup.estateLabelAdjustments.offsetY,
                      void 0,
                      { number: true }
                    ]
                  ]),
                  _createElementVNode("span", _hoisted_29, _toDisplayString($setup.estateLabelAdjustments.offsetY) + "px", 1)
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _cache[13] || (_cache[13] = _createElementVNode("label", null, "Scale", -1)),
                  _withDirectives(_createElementVNode("input", {
                    class: "control-input",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.estateLabelAdjustments.scale) = $event)),
                    type: "range",
                    min: "0.5",
                    max: "6",
                    step: "0.1"
                  }, null, 512), [
                    [
                      _vModelText,
                      $setup.estateLabelAdjustments.scale,
                      void 0,
                      { number: true }
                    ]
                  ]),
                  _createElementVNode("span", _hoisted_31, _toDisplayString($setup.estateLabelAdjustments.scale.toFixed(1)) + "x", 1)
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _cache[14] || (_cache[14] = _createElementVNode("label", null, "Rotation", -1)),
                  _withDirectives(_createElementVNode("input", {
                    class: "control-input",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.estateLabelAdjustments.rotation) = $event)),
                    type: "range",
                    min: "0",
                    max: "360",
                    step: "1"
                  }, null, 512), [
                    [
                      _vModelText,
                      $setup.estateLabelAdjustments.rotation,
                      void 0,
                      { number: true }
                    ]
                  ]),
                  _createElementVNode("span", _hoisted_33, _toDisplayString($setup.estateLabelAdjustments.rotation) + "°", 1)
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _cache[15] || (_cache[15] = _createElementVNode("label", null, "Boundary Opacity", -1)),
                  _withDirectives(_createElementVNode("input", {
                    class: "control-input",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.estateLabelAdjustments.boundaryOpacity) = $event)),
                    type: "range",
                    min: "0",
                    max: "1",
                    step: "0.05"
                  }, null, 512), [
                    [
                      _vModelText,
                      $setup.estateLabelAdjustments.boundaryOpacity,
                      void 0,
                      { number: true }
                    ]
                  ]),
                  _createElementVNode("span", _hoisted_35, _toDisplayString(($setup.estateLabelAdjustments.boundaryOpacity ?? 0.55).toFixed(2)), 1)
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _cache[16] || (_cache[16] = _createElementVNode("label", null, "Logo (optional)", -1)),
                  _createElementVNode("div", _hoisted_37, [
                    ($setup.logoUrl)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                          _createElementVNode("img", {
                            src: $setup.logoUrl,
                            alt: "Estate label logo"
                          }, null, 8, _hoisted_39),
                          _createElementVNode("button", {
                            class: "btn-remove-logo",
                            onClick: $setup.removeLogo
                          }, "Remove logo")
                        ]))
                      : (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: _normalizeClass(["btn-upload-logo", { uploading: $setup.uploadingLogo }]),
                          onClick: $setup.triggerLogoUpload
                        }, [
                          ($setup.uploadingLogo)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_40))
                            : (_openBlock(), _createElementBlock("span", _hoisted_41, "Upload logo image"))
                        ], 2)),
                    _createElementVNode("input", {
                      ref: "logoFileInput",
                      type: "file",
                      accept: "image/jpeg,image/png,image/webp",
                      style: {"display":"none"},
                      onChange: $setup.handleLogoUpload
                    }, null, 544)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_42, [
          (!$setup.hasBoundary)
            ? (_openBlock(), _createElementBlock("div", _hoisted_43, [...(_cache[18] || (_cache[18] = [
                _createElementVNode("p", null, "You can skip this step and draw the boundary later.", -1)
              ]))]))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: "btn-primary-large",
            onClick: $setup.handleComplete
          }, _toDisplayString($setup.hasBoundary ? "Continue to Set Zoom Levels →" : "Skip to Set Zoom Levels →"), 1)
        ])
      ])
    ])
  ]))
}